import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormGroup, FormsModule } from "@angular/forms";
import {
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  Subject,
  switchMap,
} from "rxjs";
import { Table, TableModule } from "primeng/table";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import buildQuery from "odata-query";
import { v4 as uuidv4 } from "uuid";
import { Address } from "../../../core/models/shared/address";
import { Currency } from "../../../core/models/shared/currencyList";
import { ReleasedProduct } from "../../../core/models/shared/releaseProduct";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { GetAllVendorsDto } from "../../../core/models/vendor/getAllVendors";
import { AddNewClientService } from "../../../core/services/add-new-client.service";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderLineItemDetailService } from "../../../core/services/order-line-item-detail.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { AccordionModule } from "primeng/accordion";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { AddressAssignmentComponent } from "../address-assignment/address-assignment.component";
import { ExchangeRatesDto } from "../../../core/models/shared/exchangeRateDto";
import { Popover, PopoverModule } from "primeng/popover";
import { PurchaseOrderHeader } from "../../../core/models/samplePO/details/purchaseOrderHeader";
import { PurchaseOrderLine } from "../../../core/models/samplePO/details/purchaseOrderLine";
import { PanelModule } from "primeng/panel";
import { ButtonModule } from "primeng/button";
import { TooltipModule } from "primeng/tooltip";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-service-template-grid",
  templateUrl: "./service-template-grid.component.html",
  styleUrls: ["./service-template-grid.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    AccordionModule,
    FormsModule,
    SelectModule,
    AddressAssignmentComponent,
    PopoverModule,
    PanelModule,
    ButtonModule,
    TooltipModule,
    InputTextModule,
  ],
})
@UntilDestroy()
export class ServiceTemplateGridComponent implements OnInit, OnChanges {
  filteredServiceLines: PurchaseOrderLine[] = [];
  @Input() shippingProductsList: ShippingMethod[] = [];
  @Input() customerId = "";
  @Input() serviceLines: PurchaseOrderLine[] = [];
  @Input() selectedLineGroup = "";
  @Input() currencyConversion!: ExchangeRatesDto;
  @Input() purchaseOrderHeader: PurchaseOrderHeader = {} as PurchaseOrderHeader;
  @Input() purchaseOrderHeaderAddress: Address = {} as Address;
  @Input() site = "";
  @Input() warehouse = "";
  @Input() purchaseOrderNumber = "";
  @Input() parent!: FormGroup;
  @Output() rowSaveEvent = new EventEmitter<PurchaseOrderLine>();
  @Output() copyLinesEvent = new EventEmitter<PurchaseOrderLine[]>();
  @Output() deleteLinesEvent = new EventEmitter<PurchaseOrderLine[]>();
  @Output() addNewServiceLine = new EventEmitter();
  @Output() editServiceLine = new EventEmitter<[PurchaseOrderLine, number]>();

  selectedServiceLines: PurchaseOrderLine[] = [];
  items: ReleasedProduct[] = [];
  unit = ["ea", "cs"];
  shipDateCurrentdate = new Date();
  descriptionCharacterCond = false;
  currencyList: Currency[] = [];
  vendorAccountNumber = "";
  vendorList: GetAllVendorsDto[] = [];

  netTotalPrice = "";
  netTotalPriceConverted = "";
  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  displayAddressAssignment = false;

  toolTipOptions = {
    autoHide: false,
    escape: false,
    tooltipEvent: "hover" as const,
    tooltipPosition: "top" as const,
    tooltipStyleClass: "tooltipwidth",
  };

  public searchVendor$ = new Subject<string>();
  @ViewChild("dt") table!: Table;

  ngOnInit(): void {
    this.getAllReleaseProduct();
    this.getCurrencyListData();
    this.searchVendorName();
  }

  constructor(
    private _samplepoListingService: SamplepoListingService,
    private _addNewClientService: AddNewClientService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _orderLineItemDetailService: OrderLineItemDetailService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    this.lineGroupChanges(changes);
    this.serviceLinesChanges(changes);
  }

  lineGroupChanges(changes: SimpleChanges) {
    if (changes["selectedLineGroup"]) {
      this.filterServiceLines();
    }
  }

  serviceLinesChanges(changes: SimpleChanges) {
    if (changes["serviceLines"]) {
      this.filterServiceLines();
    }
  }

  filterServiceLines() {
    this.selectedServiceLines = [];
    this.filteredServiceLines = this.serviceLines.filter(
      x => x.lineGroupD365 == this.selectedLineGroup
    );
  }

  addNewService() {
    // if (!this.selectedLineGroup) {
    //   this._toastr.error('Error', 'Select a line group first');
    //   return;
    // }

    this.addNewServiceLine.emit();

    // this.cancelAllEditRow();
    // const object = {
    //   id: 0,
    //   lineRecIdD365: null,
    //   siteD365: this.site,
    //   warehouseD365: this.warehouse,
    //   jobNameD365: this.parent.get('jobName')?.value,
    //   wMSLocationD365: this.parent.get('location')?.value,
    //   portalKeyD365: uuidv4(),
    //   parentD365: false,
    //   lineGroupD365: this.selectedLineGroup,
    //   purchaseOrderNumberD365: this.purchaseOrderNumber,
    //   purchaseUnitSymbolD365: 'ea'
    // } as PurchaseOrderLine;
    // this.filteredServiceLines.push(object);
    // this.serviceLines.push(object);
    // this.table.initRowEdit(this.table.value[this.table.value?.length - 1]);
  }

  onCopyLines() {
    const selectedPoLines = JSON.parse(
      JSON.stringify(this.selectedServiceLines)
    );
    // const portalOnlyLines = selectedPoLines.filter((x: any) => !x.id);
    // selectedPoLines.push(...portalOnlyLines);

    if (!selectedPoLines?.length) {
      this._toastr.error("Error", "No lines selected");
      return;
    }

    const ids = this.filteredServiceLines.map(item => item.id);
    for (const item of selectedPoLines) {
      item.id = 0;
      item.portalKeyD365 = uuidv4();
      ids.push(item.id);
    }

    this.filteredServiceLines.push(...selectedPoLines);
    this.selectedServiceLines = [];
    this._toastr.success("Success", "Line(s) Copied Successfully");
  }

  findMissingNumber(arr: number[]) {
    const numSet = new Set(arr);
    let num = 1;

    while (numSet.has(num)) {
      num++;
    }
    return num;
  }

  onDeleteLines() {
    const selectedPoLines = [...this.selectedServiceLines];
    const selectedLinesIdNotInPortal = selectedPoLines.map(
      x => x.portalKeyD365
    );

    this.filteredServiceLines = this.filteredServiceLines.filter(
      x => !selectedLinesIdNotInPortal.includes(x.portalKeyD365)
    );

    this.selectedServiceLines = [];
    this.deleteLinesEvent.emit(selectedPoLines);
    this._toastr.success("Success", "Line(s) Deleted Successfully");
  }

  clearShippingMethod(line: PurchaseOrderLine) {
    line.freightAccountNumD365 = "";
  }

  onShippingMethodSelect(shippingMethodCode: string, line: PurchaseOrderLine) {
    const index = this.shippingProductsList.findIndex(
      x => x.modeCodeD365 == shippingMethodCode
    );

    if (index > -1) {
      const selectedShippingMethod = this.shippingProductsList[index];
      if (
        selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
      ) {
        line.freightAccountNumD365 =
          selectedShippingMethod.jniFreightAcctNumD365;
      } else {
        this._orderLineItemDetailService
          .getClientFreightAccountNumber(this.customerId)
          .subscribe({
            next: res => {
              if (res.data) {
                line.freightAccountNumD365 = res.data;
              } else {
                line.freightAccountNumD365 = "";
              }
            },
            error: () => {
              line.freightAccountNumD365 = "";
            },
          });
      }
    }
  }

  addressAssignment() {
    this.displayAddressAssignment = true;
  }

  onRowEditSave(purchaseOrderLine: PurchaseOrderLine) {
    this.rowSaveEvent.emit(purchaseOrderLine);
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  getAllReleaseProduct() {
    this._samplepoListingService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.items = res.data?.filter(
            x => x.productTypeD365 == "Service" && x.poStopped === "No"
          );
        },
      });
  }

  itemSelected(
    itemNumber: SelectChangeEvent,
    purchaseOrderLine: PurchaseOrderLine
  ) {
    purchaseOrderLine.productName =
      this.items.find(x => x.itemNumberD365 == itemNumber.value)
        ?.productSearchNameD365 ?? "";
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  // shipDateChange(event: any, line: any) {
  //   line.requestedShippingDateD365 = event.target.value;
  // }

  // deliveryDateChange(event: any, line: any) {
  //   line.requestedDeliveryDateD365 = event.target.value;
  // }

  descriptionCharacterCount(obj: string) {
    if (obj && obj?.length > 45) {
      this.descriptionCharacterCond = true;
    }
  }

  patchValueInTotalNet(
    net: string,
    convertedNet: string,
    lineQuantity: string,
    lineObject: PurchaseOrderLine
  ) {
    const quantity = lineQuantity;
    if (quantity) {
      const netprice = parseFloat(net) * parseInt(quantity);
      this.netTotalPrice = netprice.toString();
      lineObject.lineAmountD365 = parseFloat(this.netTotalPrice);
      const netPriceCon =
        parseFloat(convertedNet == "" ? "0" : convertedNet) *
        parseInt(quantity);
      this.netTotalPriceConverted = netPriceCon.toString();
      lineObject.netConversionTotal = parseFloat(
        this.netTotalPriceConverted ?? "0"
      );

      if (
        this.netTotalPriceConverted &&
        this.netTotalPriceConverted != "0" &&
        lineObject?.currencyCodeD365?.toLowerCase() != "usd"
      ) {
        lineObject.amountInTransactionCurrency = parseFloat(
          this.netTotalPriceConverted ?? "0"
        );
      } else {
        lineObject.amountInTransactionCurrency = lineObject.lineAmountD365;
      }
    }
  }

  calculateQuantity(event: number, purchaseOrderLine: PurchaseOrderLine) {
    //const quantity = event;
    let quantity = event.toString().replace(/[^-0-9]/g, "");
    quantity = quantity.substring(0, 5);
    if (quantity) {
      purchaseOrderLine.orderedPurchaseQuantityD365 = parseInt(quantity);
      const netPrice = purchaseOrderLine.purchasePriceD365;
      if (netPrice) {
        //netPrice = netPrice.replace(/[^a-zA-Z0-9.]/g, '');
        const convertedNetPrice = purchaseOrderLine.netConversion;
        this.patchValueInTotalNet(
          netPrice.toString(),
          convertedNetPrice?.toString() ?? "",
          purchaseOrderLine.orderedPurchaseQuantityD365.toString(),
          purchaseOrderLine
        );
      }
    } else {
      if (quantity !== "" && !quantity) {
        purchaseOrderLine.orderedPurchaseQuantityD365 = parseInt(quantity);
      } else {
        //purchaseOrderLine.orderedPurchaseQuantityD365 = 0;
        this._toastr.error("Error", "ZERO quantity not allowed for Services");
        this._loaderService.setLoaderState(false);
      }
    }
  }

  onNetConversion(event: number, lineObject: PurchaseOrderLine) {
    let netRate = event.toString().replace(/[^0-9.]/g, "");
    const regExp = /^(\d+(\.\d+)?)$/;
    const revenue = regExp.test(netRate) ? "valid" : "invalid";
    if (lineObject.currencyCodeD365?.toLowerCase() !== "usd") {
      this.onCurrencyConversion(lineObject);
    }
    if (revenue === "valid") {
      netRate = netRate.substring(0, 9);
      lineObject.purchasePriceD365 = parseFloat(netRate);
      if (netRate) {
        if (
          this.currencyConversion &&
          lineObject?.currencyCodeD365?.toLowerCase() != "usd"
        ) {
          if (this.currencyConversion.Rate != 0) {
            this.netReteAfterConversion =
              parseFloat(netRate) * this.currencyConversion?.Rate;
            if (this.netReteAfterConversion.toString() != "") {
              this.netConvertToUsd = this.netReteAfterConversion.toString();
              lineObject.netConversion = parseFloat(
                this.netConvertToUsd ?? "0"
              );

              if (
                this.netConvertToUsd &&
                lineObject?.currencyCodeD365?.toLowerCase() != "usd"
              ) {
                lineObject.amountInTransactionCurrency = parseFloat(
                  this.netConvertToUsd ?? "0"
                );
              } else {
                lineObject.priceInTransactionCurrency =
                  lineObject.purchasePriceD365;
              }
            }
          }
        } else {
          lineObject.priceInTransactionCurrency = lineObject.purchasePriceD365;
        }
        this.patchValueInTotalNet(
          netRate,
          this.netReteAfterConversion.toString(),
          lineObject.orderedPurchaseQuantityD365?.toString() ?? "",
          lineObject
        );
      } else {
        lineObject.priceInTransactionCurrency = lineObject.purchasePriceD365;
      }
    } else {
      lineObject.purchasePriceD365 = 0;
      lineObject.lineAmountD365 = 0;
      lineObject.netConversion = 0;
      lineObject.netConversionTotal = 0;
      lineObject.priceInTransactionCurrency = 0;
      lineObject.amountInTransactionCurrency = 0;
    }
  }

  getCurrencyConvertionCode(currency: string) {
    if (currency) {
      return currency;
    } else {
      return "USD";
    }
  }

  onVendorSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    target: HTMLElement
  ) {
    mydrop.show(event, target);
  }

  searchVendorName() {
    this.searchVendor$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          const accountNumberOrName = searchitem;
          this.vendorList = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._samplepoListingService.getVendorByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.vendorList = res.data as unknown as GetAllVendorsDto[];
          }
        },
      });
  }

  onVendorRowSelection(
    vendorSelectedRow: GetAllVendorsDto,
    vendorToggle: Popover,
    serviceLine: PurchaseOrderLine
  ) {
    serviceLine.vendorNameD365 = vendorSelectedRow.vendorName ?? "";
    serviceLine.vendorIdD365 = vendorSelectedRow.vendorAccountNumber ?? "";
    this.vendorAccountNumber = vendorSelectedRow.vendorAccountNumber ?? "";
    serviceLine.currencyCodeD365 = vendorSelectedRow.currency || "USD";
    if (
      serviceLine.currencyCodeD365 &&
      serviceLine.currencyCodeD365?.toLowerCase() != "usd"
    ) {
      this.onCurrencyConversion(serviceLine);
    }

    this.clearNetInForeignCurrency(serviceLine);
    vendorToggle.hide();
  }

  selectText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  onTextFieldKeyDown(event: KeyboardEvent, serviceLine: PurchaseOrderLine, field: string) {
    const input = event.target as HTMLInputElement | HTMLTextAreaElement;
    const value = input.value;
    
    // If backspace or delete is pressed and field will become empty, set to empty string
    if ((event.key === 'Backspace' || event.key === 'Delete') && 
        (value.length === 1 || (input.selectionStart === 0 && input.selectionEnd === value.length))) {
      event.preventDefault();
      if (field === 'lineDescriptionD365') {
        serviceLine.lineDescriptionD365 = '';
      }
      input.value = '';
    }
  }

  onQuantityKeyDown(event: KeyboardEvent, serviceLine: PurchaseOrderLine) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    // If backspace or delete is pressed and field will become empty, set to 0
    if ((event.key === 'Backspace' || event.key === 'Delete') && 
        (value.length === 1 || (input.selectionStart === 0 && input.selectionEnd === value.length))) {
      event.preventDefault();
      serviceLine.orderedPurchaseQuantityD365 = 0;
      input.value = '0';
      input.select();
    }
  }

  onUnitPriceKeyDown(event: KeyboardEvent, serviceLine: PurchaseOrderLine) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    // If backspace or delete is pressed and field will become empty, set to 0
    if ((event.key === 'Backspace' || event.key === 'Delete') && 
        (value.length === 1 || (input.selectionStart === 0 && input.selectionEnd === value.length))) {
      event.preventDefault();
      serviceLine.purchasePriceD365 = 0;
      input.value = '0.0000';
      input.select();
    }
  }

  onAddressAssignment(shipTo: {
    addressD365: string;
    addressLocationNumber: number;
    addressSelectionName: string;
    deliveryNameD365: string;
  }) {
    this.selectedServiceLines.forEach(x => {
      x.deliverySelectionD365 = shipTo.addressSelectionName;
      x.shipToTypeD365 = shipTo.addressLocationNumber;
      x.postalAddressD365 = shipTo.addressLocationNumber;
      x.shipToAddressD365 = shipTo.addressD365;
      x.deliveryNameD365 = shipTo.deliveryNameD365;
      x.addressDescriptionD365 = shipTo.deliveryNameD365;
    });
  }

  clearNetInForeignCurrency(serviceLine: PurchaseOrderLine) {
    serviceLine.purchasePriceD365 = 0;
    serviceLine.lineAmountD365 = 0;
    serviceLine.priceInTransactionCurrency = 0;
    serviceLine.amountInTransactionCurrency = 0;

    this.netConvertToUsd = "";
    this.netTotalPrice = "";
    this.netTotalPriceConverted = "";
  }

  onCurrencyConversion(serviceLine: PurchaseOrderLine) {
    this._loaderService.setLoaderState(true);
    this.clearNetInForeignCurrency(serviceLine);
    const currency = serviceLine.currencyCodeD365;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });

      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            const sortedCurrency = res?.data?.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            if (sortedCurrency?.length > 0) {
              this.currencyConversion = sortedCurrency[0];
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }
  redirectToServiceEdit(line: PurchaseOrderLine, index: number) {
    this.editServiceLine.emit([line, index]);
  }
}
